import type { TaskExecutionSummary } from '@/lib/api/generated/model';
import { runCredentialMark } from '../runCredential';

/**
 * Which account a run acted as on its forges (spec 159 US3): "via GitLab"
 * or "shared account", with the per-forge detail on hover. The detail is
 * copied for assistive technology, so "shared account" is heard with its
 * reason. Nothing when the run says nothing.
 */
export function RunCredential({
  execution,
}: {
  execution: Pick<
    TaskExecutionSummary,
    'credential_source' | 'forge_credentials'
  >;
}) {
  const mark = runCredentialMark(execution);
  if (!mark) return null;
  return (
    <span className="text-muted-foreground" title={mark.lines.join('\n')}>
      {mark.label}
      <span className="sr-only">: {mark.lines.join('; ')}</span>
    </span>
  );
}
